import React from 'react';
import IntroProgressBar from './IntroProgressBar';
import StyledSurveyButton from './StyledSurveyButton';
import { introductionBtn } from '../constants/questionTypes';

function SurveyNavigationButtons({
  introQuestion,
  currentQuestionDet,
  handleBack,
  handleNext,
  surveyFinished,
  submitAnswer,
  StartSurvey,
  is_demo,
}) {
  if (surveyFinished) return null;

  const so = currentQuestionDet?.sort_order ?? 0;
  const quesType = currentQuestionDet?.quesType;
  const btnType = (currentQuestionDet?.buttonType || '').toLowerCase();

  const isIntro = quesType === 'introduction' || currentQuestionDet?.buttonType === introductionBtn;
  const isSubmit = quesType === 'submit' || btnType === 'submit';

  if (isIntro) {
    return (
      <>
        <IntroProgressBar current={(so || 1) - 1} total={introQuestion} />
        <StyledSurveyButton
          id={`nxt_btn_${currentQuestionDet?.id}`}
          type="button"
          onClick={currentQuestionDet?.id === 1 ? StartSurvey : handleNext}
        >
          {currentQuestionDet?.buttonText || 'Start'}
        </StyledSurveyButton>
      </>
    );
  }

  // enable if there is any response
  const hasResponse =
    (Boolean(currentQuestionDet?.response) &&
      (currentQuestionDet?.response === true || Boolean(currentQuestionDet?.response?.response)))
    || currentQuestionDet?.response?.feedback ? true : false;

    
  if (isSubmit) {
    return (
      <>
        <StyledSurveyButton
          id={`bk_btn_${currentQuestionDet?.id}`}
          type="button"
          onClick={handleBack}
        >
          Back
        </StyledSurveyButton>

        <StyledSurveyButton
          id={`nxt_btn_${currentQuestionDet?.id}`}
          type="button"
          onClick={() => {
            submitAnswer();
          }}
        >
          {currentQuestionDet?.buttonText || 'Submit'}
        </StyledSurveyButton>
      </>
    );
  }

  // Default "Next"
  return (
    <>
      <StyledSurveyButton
        id={`bk_btn_${currentQuestionDet?.id}`}
        type="button"
        onClick={handleBack}
      >
        Back
      </StyledSurveyButton>
      <StyledSurveyButton
        id={`nxt_btn_${currentQuestionDet?.id}`}
        type="button"
        onClick={handleNext}
        disabled={!hasResponse && !is_demo}
      >
        {currentQuestionDet?.buttonText || 'Next'}
      </StyledSurveyButton>
    </>
  );
}

export default SurveyNavigationButtons;
